import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { theme } from 'styled-tools';
import styled from 'styled-components';
import VideoPlayer from 'components/VideoPlayer';
import UnmuteOverlay from 'components/UnmuteOverlay';
import OptionsDisclaimer from 'components/OptionsDisclaimer';
import LiveVideoPlayer from 'components/VideoPlayer/LiveVideoPlayer';
import LiveVideoStatusBar from 'components/VideoPlayer/LiveVideoStatusBar';
import { useSiteSettings } from 'context/SiteSettingsContext';
import { getEpisodeFile } from 'utils/episodeHelpers';
import { autoOptimizeImage } from 'utils/functions';

const VideoPlayerWrapper = styled.div`
  align-self: center;
  background: ${theme('colors.black')};
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const LivePlayerWrapper = styled.div`
  position: relative;
  width: 100%;

  img {
    width: 100%;
  }
`;

BlockVideoPlayer.propTypes = {
  videoData: PropTypes.shape({
    bcVideoFile: PropTypes.string,
    livePlayer: PropTypes.bool,
    thumbnailImage: PropTypes.shape({
      url: PropTypes.string,
    }),
    videoLink: PropTypes.shape({
      href: PropTypes.string,
      title: PropTypes.string,
    })
  }),
};

function BlockVideoPlayer({ videoData }) {
  const { jwVideoFile, livePlayer, thumbnailImage, videoLink } = videoData;
  const { siteSettings, loading: siteSettingsLoading } = useSiteSettings();
  const [staticVideoLoaded, setStaticVideoLoaded] = useState(false);
  const [videoPlayer, setVideoPlayer] = useState();
  const videoId = jwVideoFile?.[0]?.mediaid;

  const thumbnailUrl = get(thumbnailImage, 'url');
  const thumbnailPosterImg = thumbnailUrl + '?format=pjpg&auto=webp&quality=50&width=920&disable=upscale';
  const mobileThumbnailPosterImg = thumbnailUrl + '?format=pjpg&auto=webp&quality=50&width=440&disable=upscale';
  const thumbnailSrcSet = `${mobileThumbnailPosterImg} 440w, ${thumbnailPosterImg} 920w`;

  const libraryUrl = siteSettings?.livePlayerSettings?.jwLibraryUrl;
  const streamId = siteSettings?.livePlayerSettings?.jwStreamId;
  const jwFile = streamId
    ? `https://cdn.jwplayer.com/live/broadcast/${streamId}.m3u8`
    : null;

  const onVideoPlayerLoaded = (success) => {
    setVideoPlayer(success.ref);
  }

  return (
    <VideoPlayerWrapper>
      {livePlayer && (
        <>
          <LivePlayerWrapper>
            <LiveVideoPlayer
              autoplay='muted'
              file={jwFile}
              libraryUrl={libraryUrl}
              live={true}
              onSuccess={onVideoPlayerLoaded}
              settingsLoading={siteSettingsLoading}
            />
          </LivePlayerWrapper>
          <OptionsDisclaimer
            intro='Market Data provided by CME Group & powered by dxFeed Technology. Options involve risk and are not suitable for all investors.'
            placement='homepage'
          />
          <LiveVideoStatusBar />
        </>
      )}
      {jwVideoFile && (
        <LivePlayerWrapper>
          <VideoPlayer
            autoplay={false}
            videoId={videoId}
            onSuccess={onVideoPlayerLoaded}
          />
        </LivePlayerWrapper>
      )}
    </VideoPlayerWrapper>
  );
}

export default React.memo(BlockVideoPlayer);
